import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { injectIntl } from 'react-intl';
import treeChanges from 'tree-changes';
import moment from 'moment';

import { Card, Typography } from 'antd';
import CriteriaForm from './CriteriaForm';

import LspSlsOrdFulfillmentChartActions from '../../Stores/LspSlsOrdFulfillmentChart/Actions';
import LspSlsOrdFulfillmentChart from './LspSlsOrdFulfillmentChart';

const { Text } = Typography;

class LspSlsOrdFulfillmentChartScreen extends React.PureComponent {
  componentDidMount() {
    const { curSiteFlowId, resetTimestamp } = this.props;

    if (curSiteFlowId > 0) {
      resetTimestamp();
    }
  }

  componentDidUpdate(prevProps) {
    const { fetchLspSlsOrdFulfillmentChart, curSiteFlowId, resetTimestamp, criteria } = this.props;

    const { changed } = treeChanges(prevProps, this.props);

    if (changed('curSiteFlowId')) {
      resetTimestamp();
    }

    if (changed('timestamp')) {
      if (curSiteFlowId > 0) {
        fetchLspSlsOrdFulfillmentChart(criteria);
      }
    }
  }

  render() {
    const { intl, timestamp } = this.props;

    return (
      <Card
        title={
          // eslint-disable-next-line react/jsx-wrap-multilines
          <>
            <Text>{intl.formatMessage({ id: 'logistic_order_fulfillment' })}</Text>
            <br />
            <small>
              {`${intl.formatMessage({ id: 'last_updated' })} ${moment(timestamp).format(
                'YYYY-MM-DD HH:mm:ss'
              )}`}
            </small>
          </>
        }
      >
        <CriteriaForm />
        <LspSlsOrdFulfillmentChart />
      </Card>
    );
  }
}

LspSlsOrdFulfillmentChartScreen.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  intl: PropTypes.object,
  timestamp: PropTypes.number,
  // eslint-disable-next-line react/forbid-prop-types
  criteria: PropTypes.object,

  resetTimestamp: PropTypes.func,
  fetchLspSlsOrdFulfillmentChart: PropTypes.func,

  curSiteFlowId: PropTypes.number
};

LspSlsOrdFulfillmentChartScreen.defaultProps = {
  intl: {},
  timestamp: 0,

  criteria: {},

  resetTimestamp() {},
  fetchLspSlsOrdFulfillmentChart: () => {},

  curSiteFlowId: 0
};

const mapStateToProps = state => {
  return {
    timestamp: state.lspSlsOrdFulfillmentChart.lspSlsOrdFulfillmentChartTimestamp,
    criteria: state.lspSlsOrdFulfillmentChart.criteria,
    curSiteFlowId: state.app.curSiteFlowId
  };
};

const mapDispatchToProps = dispatch => ({
  resetTimestamp: () =>
    dispatch(LspSlsOrdFulfillmentChartActions.lspSlsOrdFulfillmentChartResetTimestamp()),
  fetchLspSlsOrdFulfillmentChart: filters =>
    dispatch(LspSlsOrdFulfillmentChartActions.lspSlsOrdFulfillmentChartFetch(filters))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(LspSlsOrdFulfillmentChartScreen));
